import { X } from 'lucide-react'
import { useState, type ReactElement } from 'react'

const DISMISSED_STORAGE_KEY = 'install-hint-dismissed'

export function InstallHint(): ReactElement | null {
  const [visible, setVisible] = useState(() => {
    if (localStorage.getItem(DISMISSED_STORAGE_KEY) !== null) return false
    const { standalone } = navigator as Navigator & { standalone?: boolean }
    if (standalone !== false) return false
    return !window.matchMedia('(display-mode: standalone)').matches
  })

  if (!visible) return null

  const dismiss = (): void => {
    localStorage.setItem(DISMISSED_STORAGE_KEY, '1')
    setVisible(false)
  }

  return (
    <div
      role="status"
      className="bg-muted flex items-start justify-between gap-3 rounded-lg border p-3"
    >
      <p className="text-sm">Install: tap Share, then Add to Home Screen</p>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss install hint"
        className="text-muted-foreground shrink-0 p-1 [-webkit-tap-highlight-color:transparent]"
      >
        <X aria-hidden="true" className="size-4" />
      </button>
    </div>
  )
}
